import {useUser, logout} from '@/biz/user.mjs'

export default () => {
    const user = useUser()

    return {
        title: user?.name,

        children: [
            {
                title: '个人中心',
                to: ['/PersonalCenter'],
            },

            {
                title: '退出登录',
                onClick: logout,
            },
        ]
    }
}
